<template>
  <div class="learn-container learn-ing" oncontextmenu="return false" onselectstart="return false">
    <div class="heads flex-row-start">
      <a href="javascript:;" class="back" @click="goBack"></a>
      <div class="heads-title">当前知识点：</div>
      <div class="heads-title-value">{{ courseInfo.knowledgeString }}</div>
    </div>
    <div class="video-info-box">
      <div class="video-info flex-between">
        <div class="left">
          <!-- <div class="video"></div> -->
          <img
            src="https://wk.canpoint.net/Template/style1/style_img/xxxxxxxx.gif"
            class="vidoe-init-img"
            v-if="videoLoading"
            alt=""
          />
          <video-player
            class="video-player-box"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            customEventName="customstatechangedeventname"
            v-else
          >
          </video-player>
          <div class="intro">
            <div>课程简介：</div>
            <div class="fs-14">{{ courseInfo.ke_introduction || "" }}</div>
          </div>
        </div>
        <template v-if="isSubmit">
          <div class="right">
            <div class="right-con">
              <div class="title">
                <div>闯关卡片</div>
                <span class="record"
                  >本次得分：<span class="num-max">{{
                    scoreData.score_num
                  }}</span></span
                >
              </div>
              <div class="result-info">
                <div class="result-info-num flex-between">
                  <span>本次总题数：{{ scoreData.count }}</span>
                  <span>答对：{{ scoreData.count - scoreData.error_num }}</span>
                  <span>答错：{{ scoreData.error_num }}</span>
                  <span>正确率：{{ scoreData.accuracy }}%</span>
                </div>
                <div class="result-info-index">
                  <div class="index">
                    <span
                      v-for="(val, key) in exerciseListData"
                      :key="key"
                      :class="val.result == 1 ? 'success' : 'error'"
                      @click="onExerciseIndex(key)"
                      >{{ key + 1 }}</span
                    >
                  </div>
                  <div class="index-msg">（点击色块回顾题目）</div>
                </div>
              </div>

              <div class="result-time-box">
                <div class="result-time flex-between">
                  <div class="item-time">
                    答题用时：{{resultTime}}
                  </div>
                  <!-- <div class="item-time">单题用时：--秒</div> -->
                </div>
              </div>
              <div class="award-box">
                <div class="award">
                  获得奖励：
                  <span class="award-num fs-14"
                    >满天星*{{ scoreData.xing_chen_bi }}</span
                  >
                  <!-- <span class="award-num">全品豆*{{ scoreData.dou_num }}</span> -->
                </div>
              </div>
            </div>
            <div class="button-box flex-row">
              <div class="button-result button-bg-40B8EE" @click="goBack">
                返回目录
              </div>
              <!-- <div class="button-result">下一关卡</div> -->
            </div>
          </div>
        </template>
        <template v-else>
          <div class="right">
            <div class="right-con">
              <div class="title">
                <div class="time">
                  计时器：{{ myHours }}:{{ myMinutes }}:{{ mySeconds }}
                </div>
                <div>闯关卡片</div>
                <span class="record"
                  >当前：第<span class="num">{{ index + 1 }}</span
                  >题，共<span class="num">{{ exerciseList.length }}</span
                  >题</span
                >
              </div>
              <div class="exercise-content-box" v-if="!isNull">
                <zi-hui-xue-answer-exercise
                  :form="form"
                  :exerciseList="exerciseList"
                  @nextCallBack="onNextCallBack"
                  @submitCallBack="onSubmitCallBack"
                ></zi-hui-xue-answer-exercise>
              </div>
              <div class="exercise-content-box column" v-else>
                <img src="../../assets/images/list_null.png" alt="" srcset="" />
                <div class="null">暂无数据~~</div>
              </div>
            </div>
            <!-- <div class="button-box">
              <div class="button" @click="onNext">下一题</div>
            </div> -->
          </div>
        </template>
      </div>
    </div>

    <el-dialog
      class="dialog"
      :title="dialog.title"
      :visible.sync="dialog.status"
      width="895px"
    >
      <div class="dialog-looks-Answer">
        <zi-hui-xue-looks-answer-exercise
          :isTabShow="true"
          :index="exerciseIndex"
          :exerciseList="exerciseListData"
        ></zi-hui-xue-looks-answer-exercise>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import "video.js/dist/video-js.css";
import "@/assets/css/video.css";
import { videoPlayer } from "vue-video-player";
import ZiHuiXueLooksAnswerExercise from "../template/ZiHuiXueLooksAnswerExercise.vue";
import ZiHuiXueAnswerExercise from "../template/ZiHuiXueAnswerExercise.vue";
export default {
  components: {
    videoPlayer,
    ZiHuiXueLooksAnswerExercise,
    ZiHuiXueAnswerExercise,
  },
  data() {
    return {
      form: {},
      courseInfo: {},
      playerOptions: {},
      videoLoading: true,
      index: 0,
      exerciseListData: [],
      exerciseList: [],
      scoreData: {},
      dialog: { status: false, title: "题目作答回顾" },
      isStartQuestion:false, //是否可以答题
      exerciseIndex: 0,
      isSubmit: false,
      isNull: true,
      currentTime:0,
      myHours: "00", //  小时
      myMinutes: "00", // 分钟
      mySeconds: "00", // 秒钟
      resultTime: "",
    };
  },
  created() {
    this.videoIngTime = 0;
    this.isSetCharging = false;
    this.cid = parseInt(this.$route.params.cid);
    this.userExercise = [];
    this.exerciseListData = [];
    this.isExercise = 1;
    this.resultTypes = this.$route.query.t; //结果跳转参数
    if (this.resultTypes) {
      this.initResult();
      this.resultTime = this.resultTypes;
    }
    this.getCourseInfo();
  },
  computed: {
    ...mapState(["userAnswer"]),
  },

  methods: {
    ...mapActions(["USER_ANSWER_SIGNIN"]),
    initResult() {
      this.isExercise = 0;
      this.isSubmit = true;
      this.exerciseListData = this.userAnswer.list;
      this.scoreData = this.userAnswer.score;
    },
    getCourseInfo() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/tongbu/getByIdCourseInfo", {
        id: this.cid,
        model_type: 2,
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.warning(result.message);
            this.loading.close();
            return false;
          }
          this.courseInfo = result.data;
          this.getVideo(this.courseInfo.video_id);
          this.getQuestionList(this.courseInfo.video_id);
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getQuestionList(videoId) {
      this.getRequest("/wenjiaoopne/kc/question/getVideoIdToQuestion", {
        video_id: videoId,
        question_num: 5,
      })
        .then((result) => {
          if (result.error_code != 0) {
            return false;
          }
          this.isNull = result.data.total_count < 5;
          if(result.data.total_count < 5){
            this.$message.warning("暂无本微课练习题目"); 
            return false;
          }
          this.exerciseList = result.data.list;
          this.form = {
            keys: result.data.keys,
            course_id: this.cid,
          };
          this.timer();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getVideo(videoId){
      this.getRequest("/wenjiaoopne/kc/course/getVideoPlayUrl", {
        video_id: videoId,
        type: 3,
      })
        .then((result) => {
          if (result.error_code != 0) {
            this.$message.error(result.message)
            return false;
          }
          this.playerOptions = {
            height: 325,
            muted: false,
            autoplay: false,
            language: "zh-CN",
            preload: "auto",
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            notSupportedMessage: "此视频暂无法播放，请稍后再试",
            sources: [
              {
                type: "video/mp4",
                src: result.data.video_url,
              },
            ],
            poster: this.courseInfo.ke_images_url,
          };
          this.videoLoading = false;
          this.loading.close();
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 播放
    onPlayerPlay(player) {
      console.log("播放!", player);
      // this.player.play();
      this.setVideoCharging();
      this.setVideoInterval();
    },
    // 暂停
    onPlayerPause(player) {
      console.log("暂停!", player);
      clearTimeout(this.videoTime);
      this.setVideoTime();
    },
    // 记录播放时间
    onPlayerTimeupdate(e) {
      this.videoIngTime = e.cache_.currentTime;
    },
    setVideoCharging(){
      if(this.isSetCharging){
        return
      }
      this.isSetCharging = true;
      this.getRequest("/wenjiaoopne/kc/course/setVideoCharging", {})
        .then((result) => {
          console.log(result)
        })
        .catch(() => {});
    },
    setVideoInterval() {
      this.videoTime = setInterval(() => {
        this.setVideoTime();
      }, 3000);
    },
    setVideoTime() {
      this.getRequest("/wenjiaoopne/kc/course/setVideoTime", {
        video_id: this.courseInfo.video_id,
        play_time: this.videoIngTime,
      })
        .then(() => {})
        .catch(() => {
          clearTimeout(this.videoTime);
        });
    },
    onExerciseIndex(index) {
      this.exerciseIndex = index;
      this.dialog.status = true;
    },
    onNextCallBack(index) {
      this.index = index;
    },
    onSubmitCallBack(result) {
      clearTimeout(this.time);
      this.resultTime = `${this.myHours}:${this.myMinutes}:${this.mySeconds}`
      this.USER_ANSWER_SIGNIN(result.data);
      this.initResult();
    },
    goBack() {
      this.$router.push("/student/zihuixue?back=1");
    },
    timer() {
      this.timeFunction();
      this.time = setInterval(() => {
        this.timeFunction();
      }, 1000);
    },
    timeFunction() {
      // 开始执行倒计时
      this.timeObj = {
        
        // 时间对象
        seconds: Math.floor(this.currentTime % 60),
        minutes: Math.floor(this.currentTime / 60) % 60,
        hours: Math.floor(this.currentTime / 60 / 60) % 24,
      };
      // 计算出时分秒
      this.myHours =
        this.timeObj.hours < 10 ? "0" + this.timeObj.hours : this.timeObj.hours;
      this.myMinutes =
        this.timeObj.minutes < 10
          ? "0" + this.timeObj.minutes
          : this.timeObj.minutes;
      this.mySeconds =
        this.timeObj.seconds < 10
          ? "0" + this.timeObj.seconds
          : this.timeObj.seconds;
      this.currentTime++;
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
  destroyed() {
    clearTimeout(this.videoTime);
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
};
</script>
<style scoped>
.learn-container {
  width: 100%;
}
.learn-container .heads {
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.learn-container .back {
  display: inline-block;
  width: 91px;
  height: 50px;
  background-image: url("../../assets/images/4.gif");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.learn-container .heads-title,
.heads-title-value {
  display: inline-block;
}
.learn-container .heads-title {
  margin-left: 20px;
  color: #7a8aa3;
}
.learn-container .heads-title-value {
  color: #40b8ee;
  font-size: 24px;
}
.learn-container .video-info-box {
  width: 100%;
  height: 550px;
  background-color: #ffffff;
}
.learn-container .video-info {
  margin: 0 35px;
  padding-top: 15px;
}
.learn-container .left {
  width: 580px;
  height: 465px;
}
.learn-container .right {
  width: 520px;
  height: 465px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.learn-container .right .right-con {
  margin: 0 10px;
}
.exercise-content-box {
  margin: 0 20px;
  height: 380px;
  overflow-y: auto;
  color: #666;
}
.right-con .title {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.right-con .time {
  position: absolute;
  display: inline-block;
  left: 10px;
  bottom: 8px;
  font-size: 14px;
  color: #9aa7bd;
}
.right-con .title .record {
  position: absolute;
  display: inline-block;
  right: 10px;
  bottom: 8px;
  font-size: 14px;
  color: #9aa7bd;
}
.right-con .title .record .num {
  color: #40b8ee;
  margin: 0 2px;
}
.right-con .title .title-item {
  width: 30px;
  height: 30px;
  background-color: #b1b1b1;
  margin: 0 10px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
.right-con .stem {
  padding-bottom: 20px;
}
.right-con .explain-box {
  margin-top: 20px;
}
.right-con .explain {
  margin-top: 5px;
}
.right-con .options {
  position: relative;
}
.right-con .item {
  margin: 4px 0;
  min-width: 420px;
  display: inline-block;
  padding: 10px 5px;
  /* background-color: aliceblue; */
}
.right-con .item:hover {
  box-shadow: 0px 1px 10px #f0f0f0;
}
.button-box {
  width: 100%;
}
.button-box .button {
  padding: 8px 20px;
  text-align: center;
  border-radius: 20px;
  width: 150px;
  margin: 0 auto;
  background-color: #6fe7b3;
  cursor: pointer;
}
.dialog-looks-Answer {
  margin: 0 10px;
}
.m-10 {
  margin: 0 10px;
}
.success {
  color: #fff;
  background-color: #6fe7b3 !important;
}
.error {
  color: #fff;
  background-color: #f76570 !important;
}

.learn-container .right .title {
  width: 100%;
  height: 60px;
  text-align: center;
  border-bottom: 2px dotted #aebbd2;
  color: #40b8ee;
  font-size: 25px;
}
.learn-container .vidoe-init-img {
  width: 100%;
  height: 325px;
}
.learn-container .intro {
  width: 100%;
  margin-top: 6px;
  height: 134px;
  background-color: #f6f9ff;
  color: #9aa8c0;
}

/* 等分  结算样式 */
.num-max {
  font-size: 28px;
  color: #ad0d00;
}
.button-box .button-result {
  padding: 8px 20px;
  text-align: center;
  border-radius: 20px;
  width: 150px;
  margin: 0 auto;
  background-color: #6fe7b3;
  cursor: pointer;
}
.button-bg-40B8EE {
  background-color: #40b8ee !important;
}

.result-info {
  color: #9aa7bd;
  padding: 5px 0;
}

.result-info-index,
.result-info-num,
.award {
  margin: 20px 25px;
}

.result-info-index .index {
  margin-right: 20px;
}
.result-info-index .index,
.result-info-index .index-msg {
  display: inline-block;
  font-size: 14px;
}
.result-info-index .index span {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 15px;
  text-align: center;
  line-height: 30px;
  background-color: #71e7af;
  cursor: pointer;
}
.result-time-box {
  width: 100%;
  padding: 30px 0;
  border-top: 2px dotted #aebbd2;
  border-bottom: 2px dotted #aebbd2;
  color: #9aa7bd;
}
.result-time-box .result-time {
  margin: 0 25px;
}
.award-box {
  padding: 20px 0;
}
.award-box .award-num {
  margin-right: 15px;
}
.award-box .award {
  color: #9aa7bd;
}
.learn-container .intro > div {
  padding: 8px 15px;
}
</style>
